const OG_IMAGE = "https://customer-assets.emergentagent.com/job_a00bdaaa-d343-44f1-adb9-f8b11a8d38bf/artifacts/uebq4hba_05E57B89-22E7-4BD3-9DAB-893D2DCED5A9.jpeg";
const SITE_URL = "https://bitcoinbrain.space";

export function setPageSEO({ title, description, path }) {
  document.title = title;

  const tags = {
    "og:title": title,
    "og:description": description,
    "og:url": `${SITE_URL}${path}`,
    "og:image": OG_IMAGE,
    "og:type": "website",
    "og:site_name": "Bitcoin Brain",
    "twitter:card": "summary_large_image",
    "twitter:title": title,
    "twitter:description": description,
    "twitter:image": OG_IMAGE,
  };

  Object.entries(tags).forEach(([key, value]) => {
    const attr = key.startsWith("og:") ? "property" : "name";
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", value);
  });

  let descEl = document.querySelector('meta[name="description"]');
  if (descEl) descEl.setAttribute("content", description);

  // Set canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", `${SITE_URL}${path}`);
}
